<template>
    <Widget
            title="图片"
            icon="iconfont iconxitongguanli-jianchayiju" >
        <div slot="toolbar" class="toolbar-wrap">
            <Button type="primary" @click="showOrUpdateModal">添加分类</Button>
            <BtnUploader :fileList.sync="fileList"
                         :businessId="uploadParam.businessId"
                         :tempId="uploadParam.tempId"
                         uploadTitle="上传图片"
                         :businessType="uploadParam.businessType"
                         :single="false"
                         :businessProperty="uploadParam.businessProperty"
                         basedictStorage="ossServer"
                         :isNeed="true"
                         isNeedInfo="请选择图片所属分类"
                         ref="btnUploader"
                         :thumbWidth="queryByCategoryParam.thumbWidth"
            ></BtnUploader>
            <Button type="primary" v-if="checkImageIds.length > 0" @click="batchChangeCategory">批量修改分类</Button>
            <Button type="primary" v-if="checkImageIds.length === 0" disabled>批量修改分类</Button>

            <Button type="primary" v-if="checkImageIds.length > 0" @click="batchDelete">批量删除</Button>
            <Button type="primary" v-if="checkImageIds.length === 0" disabled>批量删除</Button>
        </div>
        <div slot="content" class="image-wrapper" v-height="{offsetHeight:125}" >
            <div class="image-wrap">
                <CheckboxGroup v-model="checkImageIds">
                    
                    <Checkbox :label="item.id" border v-for="(item,index) in fileList" :key="'finish_'+index" class="image-checkbox">
                        <Card  bordered style="margin:2px" @mouseover.native="overShow(index)" @mouseout.native="outHide()">
                            <div style="text-align:center">
                                <img :src="item.thumbnailUrl" width="120" height="120">
                                <p :title="item.filename" class="file-name">{{item.filename}}</p>
                                <div class="image-btn" v-show="hoverShowIndex===index">
                                    <Button type="warning" size="small" @click="changeCategory(item.id)">修改分类</Button>
                                    <Button type="error" size="small" @click="deleteImage(item)">删除</Button>
                                </div>
                            </div>
                        </Card>
                    </Checkbox>
                </CheckboxGroup>
            </div>
            <Modal
                    v-model="categoryChangeModal"
                    title="移动分类"
                    @on-ok="updateCategory"
                    @on-cancel="cancel">
                <Form :model="imageCategoryData" :label-width="80">
                    <FormItem label="选择分类:">
                        <Input v-model="imageCategoryData.categoryName"
                               @on-focus="showImageFlag=true"></Input>
                        <select-tree @selected-tree-value="updateImageCategory"
                                     serviceUrl='/sys/image/category'
                                     v-show="showImageFlag"/>
                    </FormItem>
                </Form>
            </Modal>
        </div>
    </Widget>
</template>

<script>
    import Widget from "@components/paas/widget";
    import BtnUploader from "@components/paas/file/btn-uploader.vue";
    import { getImagesByCategoryId,deleteImageByFileId,updateImage } from "@api/upload.js";
    import SelectTree from '@components/paas/selectTree';
    export default {
        name: "imageItem",
        components: {Widget,BtnUploader,SelectTree},
        data(){
            return {
                serviceUrl:'/sys/image/category',
                fileList:[],
                selectCategoryId:"",
                uploadParam: {
                    businessType: 'sysImage',
                    businessProperty: 'photo',
                    businessId: '',
                    tempId:"",
                },
                checkImageIds:[],
                queryByCategoryParam:{
                    query_EQ_businessId:"",
                    thumbWidth:180
                },
                hoverShowIndex:1, //显示是否删除和更改分类按钮
                //点击修改分类的时候
                imageCategoryData:{
                    id:"", //选中的文件id
                    name:"", //选中的文件名称
                    businessId:"",
                    categoryName:""
                },
                categoryChangeModal:false, //更改分类的modal
                showImageFlag:false,
            }
        },
        created(){
            //根据分类获取图片
            this.getImagesByCategoryId();
        },
        mounted(){
            this.watchUpdateTree();
        },
        methods: {
            /**
             * 移动分类
             * */
            updateCategory(){
                updateImage(this.imageCategoryData).then(res => {
                    if(res.code === 200){
                        this.getImagesByCategoryId(this.selectCategoryId);
                        for(let key in this.imageCategoryData){
                            this.imageCategoryData[key] = "";
                        }
                    }
                });
            },
            /**
             * 修改图片的分类
             * @param node
             */
            updateImageCategory(node){
                this.imageCategoryData.businessId = node.id;
                this.imageCategoryData.categoryName = node.title;
                this.showImageFlag = false;
            },
            /**
             * 查询分类图片
             * @param id
             */
            getImagesByCategoryId(id) {
                if(id){
                    this.queryByCategoryParam.query_EQ_businessId = id;
                    getImagesByCategoryId(this.queryByCategoryParam).then(res =>{
                        if (res.code === 200) {
                            this.fileList = res.data;
                        }
                    });
                }
            },
            /**
             * 点击修改分类
             * */
            changeCategory(id){
                this.imageCategoryData.id = id;
                this.categoryChangeModal = true;
            },
            /**
             * 根据文件id删除图片库文件，单个
             * */
            deleteImage(item){
                let id = item.id;
                deleteImageByFileId(id).then(res => {
                    if(res.code === 200){
                        this.$Message.info("删除成功！");
                        this.fileList = this.fileList.filter(item => {
                            return item.id !== id;
                        })
                    }
                })
            },
            /**
             *
             * 批量修改分类
             */
            batchChangeCategory(){
                this.imageCategoryData.id = this.checkImageIds.join(",");
                this.categoryChangeModal = true;
            },
            /**
             * 批量删除
             */
            batchDelete(){
                deleteImageByFileId(this.checkImageIds.join(",")).then(res => {
                    if(res.code === 200){
                        this.$Message.info("删除成功！");
                        this.fileList = this.removePointById(this.fileList,this.checkImageIds);
                        this.checkImageIds = [];
                    }
                })
            },
            /**
             * 移除fileList中checkIds的文件
             * */
            removePointById(fileList,checkIds){
                for(let i=0;i<checkIds.length;i++){
                    for(let j=0;j<fileList.length;j++){
                        if(checkIds[i] === fileList[j].id){
                            fileList.splice(j, 1);
                            break;
                        }
                    }
                }
                return fileList;
            },
            overShow(index){
                this.hoverShowIndex = index;
            },
            outHide(){
                this.hoverShowIndex = -1;
            },
            /**
             *
             * 监测到点击左侧树表
             * */
            watchUpdateTree() {
                this.$bus.on("query-list", (node) => {
                    this.selectCategoryId = node.id;
                    this.uploadParam.fileBusinessId = node.id;
                    this.$refs.btnUploader.options.query.businessId = node.id;
                    this.getImagesByCategoryId(node.id);
                })
            },

        }
    }
</script>

<style scoped>
    .toolbar-wrap{
        display: flex;
        align-items: flex-start;
        margin-top: -5px;
    }
    .toolbar-wrap > button{
        margin:0 3px;
    }
    .image-wrapper{
        position:relative;
    }
    .image-wrap .ivu-checkbox-group{
        display:flex;
        flex-wrap: wrap;
        justify-content: flex-start
    }
    .file-name{
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    /*checkbox的样式*/
    .ivu-checkbox-group-item{
        height:200px;
        position: relative;
        margin:3px;
    }
    .image-checkbox >>> .ivu-checkbox{
        position: absolute !important;
        left: 5px;
        z-index: 1;
    }
    /*.ivu-checkbox-border{
        border:none;
    }*/
    /*移动到图片显示的删除和修改分类按钮*/
    .image-btn{
        position:absolute;
        bottom: 10px;
        background: #ffffff;
    }
    .image-btn button{
        margin-left:3px;
    }
</style>
